var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronTop = function SvgChevronTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7268 15.5218C18.3475 15.9232 17.7146 15.9411 17.3132 15.5618L12 10.5409L6.68683 15.5618C6.28543 15.9411 5.65251 15.9232 5.27318 15.5218C4.89386 15.1204 4.91175 14.4875 5.31316 14.1082L11.3132 8.43818C11.6986 8.07393 12.3014 8.07393 12.6868 8.43818L18.6868 14.1082C19.0882 14.4875 19.1061 15.1204 18.7268 15.5218Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })));
};
export default SvgChevronTop;